import { render, staticRenderFns } from "./IntentList.vue?vue&type=template&id=235910e0&scoped=true"
import script from "./IntentList.vue?vue&type=script&lang=js"
export * from "./IntentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235910e0",
  null
  
)

export default component.exports